module.exports = __webpack_public_path__ + "static/img/sijie.0446f38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/sijie.png
// module id = R0RF
// module chunks = 0